import { useState, useEffect } from 'react';

const DESKTOP_BREAKPOINT = 670;

export function useIsMobile() {
    const [width, setWidth] = useState(0);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWidth(window.innerWidth);
            const handleResize = () => setWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [width]);
    return width < DESKTOP_BREAKPOINT;
} 